var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 312 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ranking-bar-gradient-dark-mode",
    y1: 3,
    x2: "100%",
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b150e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#801810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#941914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#a81916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bc1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#d11317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e20613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e31513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e31f13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e42a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e53516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e63f15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e74b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e95715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#eb6418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ec6f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ee7a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f0851c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f29222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f59e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f7aa22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fab725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fcc323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f0c21f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e1be1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1ba19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c2b71a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b3b31a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#a4b01b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#95ad22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#87aa27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#78a72c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#69a22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5aa032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4b9e34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3c9936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2b9637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1e9338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#119038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#048d38"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBar);
export default __webpack_public_path__ + "static/media/DarkBar.7ff24055.svg";
export { ForwardRef as ReactComponent };